import request from '../Functions/ajax/request'

export default async function StatsLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

async function getPage ()
{
	try
	{
		var { counts } = await request('/stats/hma')
		.config({ })
		.post({ });
	}
	catch (update)
	{
		counts = { };
	}

	return { counts: counts || { } };
}